import { createFileRoute } from "@tanstack/react-router";
import SaintMiamiPage from "@/pages/learn/SaintMiamiPage";
export const Route = createFileRoute("/locations/saint-tms-miami")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS Near Miami | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® TMS near Miami & Miami Beach: 5-day fMRI-guided depression treatment in Coral Springs, FL. Free consultation, insurance verification, and travel support.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS Near Miami | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® TMS near Miami & Miami Beach: 5-day fMRI-guided depression treatment in Coral Springs, FL. Free consultation, insurance verification, and travel support.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/locations/saint-tms-miami",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/locations/saint-tms-miami",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintMiamiPage />;
}
